(function () {
  'use strict';

  var SCOPE_SELECTOR = 'product-page';

  function closeOtherTabs(scope, activeTab) {
    var tabs = scope.querySelectorAll('toggle-tab.opened');
    for (var i = 0; i < tabs.length; i++) {
      var tab = tabs[i];
      if (tab === activeTab) continue;
      if (typeof tab.onClickHandler === 'function') {
        tab.onClickHandler();
      }
    }
  }

  function bindTab(scope, tab) {
    if (tab.dataset.gndExclusiveBound === 'true') return;
    var title = tab.querySelector('[data-js-title]');
    if (!title) return;
    tab.dataset.gndExclusiveBound = 'true';

    title.addEventListener('click', function () {
      if (tab.classList.contains('opened')) {
        closeOtherTabs(scope, tab);
      }
    });
  }

  function init() {
    var scopes = document.querySelectorAll(SCOPE_SELECTOR);
    for (var i = 0; i < scopes.length; i++) {
      var scope = scopes[i];
      var tabs = scope.querySelectorAll('toggle-tab');
      for (var j = 0; j < tabs.length; j++) {
        bindTab(scope, tabs[j]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
